import React from 'react'
import { Header } from './Header'
import { Body } from './Body'
import PropTypes from 'prop-types'

const Payment = props => {
  if (props.step !== 3) {
    return (
      <div className='col-12 box-steps-new bg-white step_inactive_container' data-index='3'>
        <Header cssColor='color-ui-3 step_icon_inactive' />
      </div>
    )
  }

  return (
    <div className='col-12 box-steps-new bg-white step_active_container' data-index='3'>
      <Header active cssColor='color-brand-1 step_icon_active_as' />
      <Body {...props} />
    </div>
  )
}

Payment.propTypes = {
  step: PropTypes.number
}

export default Payment



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Payment.js